import { render, staticRenderFns } from "./NewFormPage.vue?vue&type=template&id=31a00b55&scoped=true"
import script from "./NewFormPage.vue?vue&type=script&lang=js"
export * from "./NewFormPage.vue?vue&type=script&lang=js"
import style0 from "./NewFormPage.vue?vue&type=style&index=0&id=31a00b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a00b55",
  null
  
)

export default component.exports